import PropTypes from "prop-types";
import React from "react";
import { primary, darkGray } from "@govlaunch/palette";
import { Chevron } from "@govlaunch/core";

export default function TopBottomChevron({ disabled, large, small }) {
  const size = large || small ? 12 : 10;

  return (
    <div css={topBottomChevronStyle}>
      <div
        css={{
          marginBottom: 2,
        }}
      >
        <Chevron size={size} color={disabled ? darkGray : primary} direction="top" />
      </div>
      <Chevron size={size} color={disabled ? darkGray : primary} direction="bottom" />
    </div>
  );
}

TopBottomChevron.propTypes = {
  large: PropTypes.bool,
  small: PropTypes.bool,
  disabled: PropTypes.bool,
};

TopBottomChevron.defaultProps = {
  disabled: false,
  large: false,
  small: false,
};

const topBottomChevronStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  marginLeft: "auto",
};
